import type { ITableData } from "../types";

// Content-based px column widths for the mobile overflow-scroll layout.
export const getMobileColWidths = (
  tableData: ITableData,
  tableCols: number,
  tableRows: number,
): string[] =>
  Array.from({ length: tableCols }, (_, col) => {
    let maxLen = 0;
    for (let row = 0; row < tableRows; row++) {
      const cell = tableData[row * tableCols + col];
      if (cell?.content) {
        const stripped = cell.content.replace(/<[^>]*>/g, "");
        maxLen = Math.max(maxLen, stripped.length);
      }
    }
    return maxLen <= 10 ? "80px" : maxLen <= 30 ? "128px" : "180px";
  });
